import { isDashboardPageAction, initDashboard, isFundResponseReduxQueryAction, getClearedDashboardState, closeDetailPanels, isLocationChangeAction, isPortfolioResponseReduxQueryAction, isAssetResponseReduxQueryAction, isManagerResponseReduxQueryAction, isMarketResponseReduxQueryAction, isFundSeriesResponseReduxQueryAction } from "./utils";
import { initialDashboardState } from ".";
import { queryParams } from "common/constants";
import { DashboardTypes } from "components/workspaces/hooks/types";
import { dashboardPageDefinitionsByLocationPath } from "components/workspaces/hooks/use-get-dashboards-by-type";
import { setLogout } from "store/auth";
export const currentDashboardExtraReducers = (builder) => {
    builder
        .addCase(setLogout, (state) => Object.assign(state, initialDashboardState))
        .addMatcher((action) => isDashboardPageAction(action), (state, action) => {
        const [dashboardType, requestedId] = action.payload.location.pathname.split("/").filter((e) => e), page = dashboardPageDefinitionsByLocationPath[`/${dashboardType}/`], searchParams = new URLSearchParams(action.payload.location?.search);
        const previousDashboardEntityId = state.currentEntityId, previousDashboardType = state.currentType;
        const investorId = searchParams.get(queryParams.investorIdParamName);
        initDashboard(state, requestedId, investorId);
        if (page.dashboardType === DashboardTypes.Asset && previousDashboardType === DashboardTypes.Fund) {
            state.dashboardOptions = { selectedFundId: previousDashboardEntityId };
        }
        state.currentType = dashboardType;
    })
        .addMatcher((action) => isFundResponseReduxQueryAction(action), (state, action) => {
        if (!state.isManualChangeDate) {
            const fund = action.entities.Fund[Object.keys(action.entities.Fund)[Object.keys(action.entities.Fund).length - 1]];
            let referenceDate = fund.latestCapitalAccountReportedDate;
            if (state.dashboardOptions?.selectedInvestorId) {
                const subscription = fund.subscriptions.find((e) => e.investmentId === state.dashboardOptions?.selectedInvestorId);
                if (subscription && subscription.lastInvestorCashFlowDate) {
                    referenceDate = subscription.lastInvestorCashFlowDate;
                }
            }
            state.referenceDate = referenceDate;
        }
    })
        .addMatcher((action) => isFundSeriesResponseReduxQueryAction(action), (state, action) => {
        if (!state.isManualChangeDate) {
            state.referenceDate = action.entities.FundSeries[Object.keys(action.entities.FundSeries)[Object.keys(action.entities.FundSeries).length - 1]]
                .referenceDate;
        }
    })
        .addMatcher((action) => isPortfolioResponseReduxQueryAction(action), (state, action) => {
        if (!state.isManualChangeDate) {
            state.referenceDate = action.entities.Portfolio[Object.keys(action.entities.Portfolio)[Object.keys(action.entities.Portfolio).length - 1]].latestInvestorCfDate;
        }
    })
        .addMatcher((action) => isManagerResponseReduxQueryAction(action), (state, action) => {
        if (!state.isManualChangeDate) {
            state.referenceDate = action.entities.Manager[Object.keys(action.entities.Manager)[Object.keys(action.entities.Manager).length - 1]]
                .latestCapitalAccountReportedDate;
        }
    })
        .addMatcher((action) => isAssetResponseReduxQueryAction(action), (state, action) => {
        if (!state.isManualChangeDate) {
            state.referenceDate = action.entities.Asset[Object.keys(action.entities.Asset)[0]].referenceDate;
        }
    })
        .addMatcher((action) => isMarketResponseReduxQueryAction(action), (state, action) => {
        if (!state.isManualChangeDate) {
            state.referenceDate = action.entities.Market[Object.keys(action.entities.Market)[0]].referenceDate;
        }
    })
        .addMatcher((action) => isLocationChangeAction(action) && !isDashboardPageAction(action), (state) => getClearedDashboardState(state))
        .addMatcher((action) => isLocationChangeAction(action) && isDashboardPageAction(action), (state) => closeDetailPanels(state));
};
